import { createApp, getCurrentInstance } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    compilerOptions: {
      // register any non-vue custom elements we can use inside this app
      isCustomElement: (tag) => ["g-map", "g-marker"].includes(tag),
    },
    props: [
      'el'
    ],
    data(){
      return {
        // internal data
        localizeData: {},
        paginationType: 'pagination', //pagination|loadmore
        loading: false,
        posts: [],
        totalPosts: 0,
        page: 1,
        maxPages: 1,
        dirty: false,
        ariaAnnouncement: '',

        // localized data
        postsPerPage: 12, //this.localizeData.postsPerPage,
        postType: 'post', //this.localizeData.postType,
        taxonomies: [], //this.localizeData.taxonomies,
        metafields: [], //this.localizeData.metafields,

        //user data
        sort: "DESC",
        selectedFilters: {},
        selectedMetafilters: {},
        search: '',
      }
    },
    mounted(){
      const localId = this.el.closest(".post-listing--app").getAttribute('localized-data-id')
      if(localId){
        this.localizeData = window[localId]
        this.postsPerPage = this.localizeData.postsPerPage
        this.postType = this.localizeData.postType
        this.taxonomies = this.localizeData.taxonomies
        this.metafields = this.localizeData.metafields
      }

      this.metafields.forEach(field => {
        this.selectedMetafilters[field.slug] = []
      })

      this.taxonomies.forEach(tax => {
        this.selectedFilters[tax.name] = []
      })

      if(this.localizeData.prefilterTermId && this.localizeData.prefilterTermId != -1){
        let found = false

        this.taxonomies.forEach(tax => {
          tax.terms.forEach(term => {
            if(term.term_id == this.localizeData.prefilterTermId){
              found = true
              this.selectedFilters[tax.name] = [ term.term_id ]
              // keep the weird dropdowns up to date
              if(this.$refs[`${tax.name}Dropdown`]){
                this.$refs[`${tax.name}Dropdown`].forEach(el => el.value = term.term_id)
              }
            }
          })
        })

        if(!found){
          console.warn(`The term ID ${this.localizeData.prefilterTermId} is trying to be prefiltered, but its term doesn't exist in the passed taxonomies. This usually means there are no posts associated with the prefiltered term ID.`)
          if(Object.keys(this.selectedFilters).length){
            // push an impossible number into any filter to ensure that no posts show up
            Object.values(this.selectedFilters)[0].push(-1)
          }
        }
      }

      this.setFromUrl()

      this.fetchPosts(false, false, false)
    },
    methods: {
      isTaxonomyPreset(tax){
        return tax.terms.map(t => t.term_id).indexOf(this.localizeData.prefilterTermId) == -1
      },
      taxonomyShouldDisplay(tax){
        let shouldDisplay = true

        if(shouldDisplay && this.localizeData.prefilterTermId){
          shouldDisplay = this.isTaxonomyPreset(tax)
        }

        if(shouldDisplay && tax.terms.length < 2){
          shouldDisplay = false
        }

        if(shouldDisplay && this.localizeData.ignoreCategories.indexOf(tax.name) !== -1){
          shouldDisplay = false
        }

        return shouldDisplay
      },
      formatSymbols(text) {
        // replace symboles that are confusing to screen readers to english words
        return text.replace(/&amp;|&|\+/g, 'and');
      },
      manualFormSubmission(){
        this.fetchPosts(true, true, true)
      },
      setPage(page){
        this.page = parseInt(page)
        this.fetchPosts(false, true, true)
      },
      setAriaAnnouncement(){
        if(!this.dirty){
          this.ariaAnnouncement = ''
          return ''
        }

        let str = ''

        if(this.search != ''){
          str += `<p>You searched for "${this.search}".</p>`
        }

        let filters = []
        for(let taxonomy_name in this.selectedFilters){
          if(this.selectedFilters[taxonomy_name]){
            const foundTaxObj = this.taxonomies.filter(t => t.name == taxonomy_name)
            if(foundTaxObj.length && this.selectedFilters[taxonomy_name]?.length && this.selectedFilters[taxonomy_name].length){
              this.selectedFilters[taxonomy_name].forEach(term_id => {
                const foundTerm = foundTaxObj[0].terms.filter(t => t.term_id == term_id)
                if(foundTerm.length){
                  filters.push(foundTerm[0].name)
                }
              })
            }
          }
        }

        let metafilters = []
        for(let key in this.selectedMetafilters){
          if(this.selectedMetafilters[key]){
            this.selectedMetafilters[key].forEach(label => {
              metafilters.push(label)
            })
          }
        }        

        if(filters.length){
          str += `<p>You filtered by ${this.formatSymbols(filters.join(', ')).replace(/, ([^,]*)$/, ' and $1')}.</p>`;
        }

        if(metafilters.length){
          str += `<p>You filtered by ${this.formatSymbols(metafilters.join(', ')).replace(/, ([^,]*)$/, ' and $1')}.</p>`
        }

        //If there are posts, tell how many are showing & what page we're on
        if (this.posts.length) {
          let start = '';
          let end = '';
          if(this.page == this.maxPages){
            start = this.totalPosts - this.posts.length + 1;
            end = this.totalPosts;
          }
          else{
            start = 1 + (this.posts.length * (this.page - 1));
            end = this.posts.length * this.page;
          }
          
          str += `<p>Showing ${start} to ${end} of ${this.totalPosts}.</p>`;
        } else {
          str = '';
        }

        //If there are no posts, say we can't find any
        if(this.dirty && !this.posts.length){
          str = '' //`<p>Sorry, no posts match that search criteria.</p>`;
        }

        this.ariaAnnouncement = str.trim()

      },
      taxonomyCheckboxChange(){
        this.taxonomies.map(t => t.name).forEach(termSlug => {
          // keep the weird dropdowns up to date ----- this probably isn't needed anymore? we force people to choose one or the other
          if(this.$refs[`${termSlug}Dropdown`]){
            this.$refs[`${termSlug}Dropdown`].forEach(el => {
              if(this.selectedFilters[termSlug].length){
                el.value = this.selectedFilters[termSlug][this.selectedFilters[termSlug].length - 1]
              } else {
                el.value = ""
              }
            })
          }
        })   
        this.manualFormSubmission()     
      },
      metafieldCheckboxChange(){
        this.manualFormSubmission()
      },
      taxonomyDropdownChange(){
        this.taxonomies.map(t => t.name).forEach(termSlug => {
          if(this.$refs[`${termSlug}Dropdown`]){
            this.$refs[`${termSlug}Dropdown`].forEach(el => {
              if(el.value){
                this.selectedFilters[termSlug] = [ el.value ]
              } else {
                this.selectedFilters[termSlug] = [ ]
              }
            })
          }
        })
        this.manualFormSubmission()
      },
      metafieldDropdownChange(){
        this.metafields.map(t => t.slug).forEach(metaSlug => {
          if(this.$refs[`${metaSlug}Dropdown`]){
            this.$refs[`${metaSlug}Dropdown`].forEach(el => {
              if(el.value){
                this.selectedMetafilters[metaSlug] = [ el.value ]
              } else {
                this.selectedMetafilters[metaSlug] = [ ]
              }
            })
          }
        })
        this.manualFormSubmission()
      },
      setFromUrl(){
        const params = Object.fromEntries(new URLSearchParams(window.location.search).entries())
        if(params?.search){
          this.search = params.search
        }
        if(params?.pg){
          this.page = parseInt(params.pg)
        }

        this.taxonomies.map(t => t.name).forEach(termSlug => {
          let cleanId
          const paramSlug = 'term_' + termSlug // prepend the param slug so it doesn't mess with query vars
          if(params[paramSlug]){

            params[paramSlug].split(',').forEach(termId => {
              cleanId = parseInt(termId) == termId ? termId : null
              // this checks if a slug is used instead of an ID and converts it
              if(!cleanId){
                this.taxonomies.forEach(tax => {
                  if(tax.name == termSlug){
                    tax.terms.forEach(term => {
                      if(term.slug == termId){
                        cleanId = term.term_id
                      }
                    })
                  }
                })
              }

              if(cleanId){
                this.selectedFilters[termSlug].push(cleanId)
              }
            })

            // keep the weird dropdowns up to date
            if(cleanId){
              setTimeout(() => {
                if(this.$refs[`${termSlug}Dropdown`]){
                  this.$refs[`${termSlug}Dropdown`].forEach(el => el.value = cleanId)
                }
              }, 100)
            }
          }
        })

        // Handle metafilter URL parameters
        this.metafields.map(f => f.slug).forEach(metaSlug => {
          if(params[metaSlug]){
            params[metaSlug].split(',').forEach(value => {
              if(value){
                this.selectedMetafilters[metaSlug].push(value)
              }
            })

            // keep dropdowns up to date
            setTimeout(() => {
              if(this.$refs[`${metaSlug}Dropdown`]){
                this.$refs[`${metaSlug}Dropdown`].forEach(el => el.value = params[metaSlug].split(',')[0])
              }
            }, 100)
          }
        })
      },
      getTaxBySlug(slug){
        const found = this.taxonomies.filter(t => t.name == slug)
        return found.length ? found[0] : null
      },
      pushToUrl() {
        const params = {}

        if(this.search.length){
          params.search = this.search
        }
        if(this.paginationType == 'pagination' && this.page != 1){
          params.pg = this.page
        }
        for(let p in this.selectedFilters){ 
          if(this.selectedFilters[p].length){
            const termIdsToAdd = this.selectedFilters[p].filter(id => id != this.localizeData.prefilterTermId)
            if(termIdsToAdd.length){
              // prepend the param slug so it doesn't mess with query vars
              params['term_' + p] = termIdsToAdd.join(',')
            }
          }
        }
        // Add metafilter parameters to URL
        for(let slug in this.selectedMetafilters){
          if(this.selectedMetafilters[slug].length){
            params[slug] = this.selectedMetafilters[slug].join(',')
          }
        }

        const oldString = window.location.search
        const queryString = new URLSearchParams(params).toString()

        if (oldString !== `?${queryString}`) { 
          if(queryString){
            const newUrl = `${window.location.pathname}?${queryString}`
            window.history.pushState(params, '', newUrl)
          } else {
            const newUrl = `${window.location.pathname}`
            window.history.pushState(params, '', newUrl)
          }
        }
      },
      shouldShow(test, i = null) {
        if (i == 1 || i == this.maxPages) {
          return false; // these always return false because we always show page 1 and {max}
        }

        const stepsFromCurrent = 2; // setting this to something huge will show all pages

        switch (test) {
          case 'pagination':
            return this.paginationType == 'pagination' && this.maxPages > 1;
          case 'prev-button':
            return this.page != 1;
          case 'next-button':
            return this.page != this.maxPages;
          case 'jump-first-dots':
            return this.page > stepsFromCurrent + 2;
          case 'jump-last-dots':
            return this.page < this.maxPages - (stepsFromCurrent + 1);
          case 'pagination-i':
            return Math.abs(i - this.page) <= stepsFromCurrent;
        }
        return false;
      },
      fetchPosts(resetPage, setFocus = false, shouldPushHistory = true){
        this.loading = true

        if(resetPage){
          this.page = 1
        }

        if(this.paginationType == 'loadmore' && shouldPushHistory) {
          this.page = this.page + 1
        }

        // force a screen reader to say "Loading..."
        if(setFocus){
          this.$nextTick(() => {
            this.$refs.loading.tabIndex = -1
            this.$nextTick(() => this.$refs.loading.focus())
          })
        }

        const formDataObj = Object.fromEntries(new FormData(this.$refs.form).entries());

        jQuery.ajax({
          url: coolfse.ajaxUrl, //localized variable
          method: "POST",
          data: {
            action: 'fetch_posts',
            sort: this.sort,
            post_type: this.postType,
            page: this.page,
            search: this.search,
            filters: this.selectedFilters,
            metafilters: this.selectedMetafilters,
            posts_per_page: this.postsPerPage,
            raw_form_data: formDataObj
          },
          complete: data => {
            let totalPostsBeforeFetch = this.posts.length
            const response = data.responseJSON.data

            if(data.status == 200){
              
              if(this.paginationType == 'pagination') {
                this.posts = response.posts  
              } else {
                response.posts.forEach(post => this.posts.push(post))
              }

              this.maxPages = response.maxPages
              this.totalPosts = response.postsFound
            } else {
              alert('Something went wrong. Please try again later.')
            }

            this.loading = false

            this.dirty = true

            this.setAriaAnnouncement()

            //we shouldn't push history if the browser is using "popstate"
            if(shouldPushHistory){
              this.pushToUrl()
            }

            if(setFocus){
              this.$nextTick(() => {
                if(this.$refs.noPostsFoundMessage){
                  // if no posts found... focus that
                  this.$refs.noPostsFoundMessage.focus()
                } else if(this.$refs.ariaAnnouncement){
                  // if posts found... focus total found message
                  this.$refs.ariaAnnouncement.focus()
                } else {
                  // if no total found message... try and focus a post
                  let posts = this.$refs.posts
                  if(posts){
                    let post = null
                    if(this.paginationType == 'loadmore'){
                      post = posts.querySelectorAll('.col')[totalPostsBeforeFetch]
                    } else {
                      post = posts.querySelector('.col')
                    }
                    if(post){
                      const tabbable = post.querySelector('a,input,button,iframe')
                      if(tabbable){
                        tabbable.focus()
                      } else {
                        post.tabIndex = -1
                        post.focus()
                      }
                    }
                  }
                }
              })
            }
          }
        })
      },
      resetFilters() {
        this.metafields.forEach(field => {
          this.selectedMetafilters[field.slug] = []
        })
        this.taxonomies.forEach(tax => {
          this.selectedFilters[tax.name] = []
        })
        this.search = ''
        this.fetchPosts(true, true, true)
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.post-listing--app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig, { el })
        app.mount(el)
      })
    }
  }

  initApp()
}